var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuCoffeShops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2745 0.972824C18.7654 1.13133 19.0977 1.58641 19.0977 2.10284C19.1079 2.32783 19.1079 2.5119 19.1079 2.5119C19.1079 2.5119 19.1028 8.78582 11.6733 14.5586C8.65141 16.9107 6.03344 20.7252 5.34827 24.2942C5.26135 24.7749 4.88808 25.1481 4.41255 25.2453C3.93702 25.3475 3.45127 25.1481 3.18027 24.7442C1.06339 21.6047 -1.33982 15.7449 2.66383 8.80116C6.27377 2.54258 12.9363 -0.653181 18.2745 0.972824ZM16.6945 2.94653C12.1028 2.37896 7.59809 5.16566 4.79093 10.0283C2.56157 13.8939 2.99108 18.2811 4.0853 21.1803C4.98523 18.4958 6.74418 15.2847 10.17 12.6207C14.5316 9.23067 16.2241 4.81796 16.6945 2.94653Z",
    fill: "#240b3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81186 28.5979C7.30054 28.4342 6.95284 27.9587 6.94773 27.4218C6.9375 27.2122 6.9375 27.0485 6.9375 27.0485C6.9375 27.0485 6.94773 20.7746 14.3721 15.0018C17.3685 12.6753 19.966 8.90173 20.6818 5.36338C20.779 4.8674 21.1625 4.48391 21.6585 4.38676C22.1544 4.2896 22.6555 4.49925 22.9368 4.91853C25.0383 8.0785 27.3444 13.8922 23.3816 20.7593C19.7819 27.0025 13.1449 30.2034 7.81186 28.5979ZM9.35605 26.6139C13.9477 27.1866 18.4474 24.3948 21.2596 19.5321C23.489 15.6665 23.0595 11.2794 21.9653 8.38018C21.0602 11.0697 19.3013 14.2808 15.8805 16.9397C11.5189 20.3298 9.82136 24.7425 9.35605 26.6139Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuCoffeShops);
export default __webpack_public_path__ + "static/media/new-menu-coffe-shops.b9dc9dce6d875dbafac53d7ea7d8d29e.svg";
export { ForwardRef as ReactComponent };